import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'

const styles = theme => ({})
export default withStyles(styles)(
  class TaxeSelectionComponent extends Component {
    static propTypes = {
      className: PropTypes.string,
      selectedTaxe: PropTypes.object.isRequired,
      taxes: PropTypes.array.isRequired,
      onChange: PropTypes.func.isRequired
    }
    static defaultProps = {
      taxes: []
    }
    handleChange = name => e => {
      const { taxes } = this.props
      const key = e.target.value
      const taxe = taxes.find(p => p.key === key)
      this.props.onChange(taxe)
    }
    render() {
      const { className, taxes, selectedTaxe } = this.props
      const taxesToShow = taxes.filter(t => !!Number(t.tax_enabled))
      return (
        <FormControl fullWidth={!!className} className={className}>
          <InputLabel htmlFor="pricing-select">TVA (%)</InputLabel>
          <Select
            value={selectedTaxe.key}
            onChange={this.handleChange('taxe')}
            inputProps={{
              name: 'pricing',
              id: 'pricing-select'
            }}>
            {taxesToShow.map(t => (
              <MenuItem key={t.key} value={t.key}>
                {`${Number(Number(t.tax_value) * 100).toFixed(2)}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/taxes/TaxeSelectionComponent.js